import React from 'react';
import { Box, Typography } from '@mui/material';

import ChipFilter from '../../../../components/filters/ChipFilter';
import DateRangePicker from '../../../../components/filters/DateRangePicker';
import styles from './StructureLogFilters.styles';

export default function StructureLogFilters({
  filters,
  setFilters,
  dateRange,
  setDateRange,
  fileNameOptions = [],
  statusOptions = [],
  reqTypeOptions = [],
}) {
  const toggleFilter = (type, value) => {
    setFilters((prev) => {
      const current = prev[type] || [];
      const updated = current.includes(value)
        ? current.filter((o) => o !== value)
        : [...current, value];
      return { ...prev, [type]: updated };
    });
  };

  const clearFilter = (type) => {
    setFilters((prev) => ({ ...prev, [type]: [] }));
  };

  return (
    <Box sx={styles.filterRow}>
      <Box sx={styles.filterLeft}>
        <Typography sx={styles.label}>Filters:</Typography>

        <ChipFilter
          label="Type"
          type="reqtype"
          values={reqTypeOptions}
          selectedValues={filters.reqtype}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />

        <ChipFilter
          label="Filename"
          type="fileName"
          values={fileNameOptions}
          selectedValues={filters.fileName}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />

        <ChipFilter
          label="Status"
          type="status"
          values={statusOptions}
          selectedValues={filters.status}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />

        <DateRangePicker dateRange={dateRange} setDateRange={setDateRange} />
      </Box>
    </Box>
  );
}
